import _toConsumableArray from "D:\\agent\\_work\\82\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "D:\\agent\\_work\\82\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _slicedToArray from "D:\\agent\\_work\\82\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _defineProperty from "D:\\agent\\_work\\82\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { AppBar, Badge, Button, createStyles, IconButton, Menu, MenuItem, Popover, Toolbar, withStyles } from "@material-ui/core";
import AccountCircleOutlinedIcon from "@material-ui/icons/AccountCircleOutlined";
// import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import MenuIcon from "@material-ui/icons/Menu";
import PeopleOutlinedIcon from "@material-ui/icons/PeopleOutlined";
import NotificationsNoneIcon from "@material-ui/icons/NotificationsNone";
// import PowerSettingsNew from "@material-ui/icons/PowerSettingsNew";
import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { LoginButton } from "../";
import { useAuth0 } from "../../auth/react-auth0-wrapper";
import samplesApi from "../../dal/samples";
import { getPopularTestCodesByInstitution } from "../../dal/tests";
import { colors, fonts } from "../../theme";
import { HeaderMenu } from "../HeaderMenu";
// import { HeaderOverlay } from "../HeaderOverlay";
// import HorizontalRibbon from "../HorizontalRibbon";
import CatalogHeader from "./CatalogHeader/CatalogHeader";
import OrderDropdown from "./OrderDropdown";
import VobDropdown from "./VobDropdown";
import physiciansApi from "../../dal/physicians";
import testsApi from "../../dal/tests";
import { HeaderOverlay } from "../HeaderOverlay";
var styles = function styles(theme) {
  var _iconSize;
  return createStyles({
    accountButton: _defineProperty({
      color: "white",
      fontFamily: fonts.fonts
    }, theme.breakpoints.down("md"), {
      height: 20
    }),
    userNameInfo: {
      padding: "5px 5px",
      textAlign: "left"
    },
    capitalizeText: _defineProperty({
      textTransform: "capitalize"
    }, theme.breakpoints.down("md"), {
      fontSize: "0.68rem"
    }),
    iconSize: (_iconSize = {
      fontSize: "1.5em"
    }, _defineProperty(_iconSize, theme.breakpoints.down("md"), {
      fontSize: "2em"
    }), _defineProperty(_iconSize, "color", "#0C2340"), _iconSize),
    notificationButtonRoot: {
      paddingLeft: 10,
      minWidth: 0,
      marginBottom: 4,
      textTransform: "none",
      fontWeight: "normal"
    },
    notificationButtonIcon: _defineProperty({
      fill: "white",
      marginTop: "4px",
      marginBottom: "4px",
      fontSize: "2.1em"
    }, theme.breakpoints.down("md"), {
      fontSize: "2.5em"
    }),
    badge: {
      marginLeft: -5,
      marginBottom: -5
    },
    notificationButtonLabel: _defineProperty({
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      color: "white",
      fontSize: "0.75rem"
    }, theme.breakpoints.down("md"), {
      fontSize: "0.6rem"
    }),
    headerLogo: _defineProperty({
      display: "inline-block",
      marginLeft: "-1.5em",
      height: "37px",
      width: "231px"
    }, theme.breakpoints.down("md"), {
      height: "2.2rem"
    }),
    headerLogoContainer: {
      flexGrow: 1,
      display: "flex",
      marginTop: "auto",
      marginBottom: "auto"
    },
    loginButton: {
      marginLeft: -10,
      marginBottom: 25
    },
    hamburgerButton: {
      marginBottom: "6px"
    },
    loginContainer: {
      padding: "5px 0px"
    },
    menuItem: {
      width: "15em",
      color: "#0C2340"
    },
    appBar: {
      backgroundColor: colors.white,
      opacity: 0.87
    },
    toggleUiMenuItem: {
      display: "flex",
      columnGap: "16px",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
      color: "#0C2340"
    },
    version: {
      display: "flex",
      justifyContent: "flex-end",
      textAlign: "right",
      padding: "0 16px",
      fontSize: "10px"
    },
    toolbar: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: theme.spacing(0, 2),
      minHeight: 69
    },
    leftSection: {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(2)
    },
    logoLink: {
      display: "flex",
      alignItems: "center"
    },
    logo: {
      height: 36
    },
    v2NavLink: {
      color: "#0C2340",
      fontFamily: fonts.fonts,
      fontSize: "1rem",
      fontWeight: 500,
      textDecoration: "none",
      padding: theme.spacing(0.5, 1),
      "&:hover": {
        textDecoration: "underline"
      }
    }
  });
};
var Header = function Header(_ref) {
  var hideLogin = _ref.hideLogin,
    _ref$showHamburger = _ref.showHamburger,
    showHamburger = _ref$showHamburger === void 0 ? false : _ref$showHamburger,
    institutionCode = _ref.institutionCode,
    classes = _ref.classes,
    isOnlyForLoading = _ref.isOnlyForLoading,
    _ref$showV2ProfileLin = _ref.showV2ProfileLinks,
    showV2ProfileLinks = _ref$showV2ProfileLin === void 0 ? false : _ref$showV2ProfileLin;
  var _useAuth = useAuth0(),
    isAuthenticated = _useAuth.isAuthenticated,
    loginWithRedirect = _useAuth.loginWithRedirect,
    logout = _useAuth.logout,
    selectedInstitution = _useAuth.selectedInstitution,
    physician = _useAuth.physician,
    emailVerified = _useAuth.emailVerified;
  var chooseLogo = function chooseLogo() {
    return window.innerWidth > 500 ? "/images/logo2.svg" : "/images/logo-stack-reverse.svg";
  };
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    alertData = _useState2[0],
    setAlertData = _useState2[1];
  var _useState3 = useState({
      account: null,
      addButton: null,
      notification: null,
      menu: null
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    anchors = _useState4[0],
    setAnchors = _useState4[1];
  var configData = localStorage.getItem("tenantConfig");
  var parcedConfig = JSON.parse(configData);
  var MS_LOGOUT_URL = "https://login.microsoftonline.com/common/oauth2/v2.0/logout";
  var APP_LOGOUT_REDIRECT = parcedConfig && parcedConfig.logoutRedirectUrl; // change if needed
  var _useState5 = useState(undefined),
    _useState6 = _slicedToArray(_useState5, 2),
    popularTestCodes = _useState6[0],
    setPopularTestCodes = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    favoriteTests = _useState8[0],
    setFavoriteTests = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    loading = _useState0[0],
    setLoading = _useState0[1];
  var isCatalogPage = location.href.toLowerCase().includes(window.appConfig.catalogUrl);
  var toggleAnchorClick = function toggleAnchorClick(anchorKey, event) {
    setAnchors(Object.assign(Object.assign({}, anchors), _defineProperty({}, anchorKey, anchors[anchorKey] === null && event !== undefined ? event.currentTarget : null)));
  };
  var _useState1 = useState(chooseLogo()),
    _useState10 = _slicedToArray(_useState1, 2),
    logo = _useState10[0],
    setLogo = _useState10[1];
  useEffect(function () {
    var handleResize = function handleResize() {
      return setLogo(chooseLogo());
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return function () {
      return window.removeEventListener("resize", handleResize);
    };
  }, []);
  var _useAuth2 = useAuth0(),
    isAdmin = _useAuth2.isAdmin,
    isVA = _useAuth2.isVA;
  useEffect(function () {
    var getHeaderAlert = function getHeaderAlert() {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return samplesApi.getHeaderAlert(selectedInstitution && selectedInstitution.institutionCode || "");
              case 2:
                result = _context.sent;
                setAlertData(result);
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    };
    if (!isAuthenticated || !(selectedInstitution && selectedInstitution.institutionCode || alertData !== undefined)) {
      return;
    }
    if (!isOnlyForLoading) {
      try {
        getHeaderAlert();
      } catch (e) {}
    }
  }, []);
  useEffect(function () {
    var getPopular = function getPopular(intitutionCode) {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var testCodes, vaPanels, vaTests, completeTests, uniqueTests;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return getPopularTestCodesByInstitution(intitutionCode);
              case 2:
                testCodes = _context2.sent;
                if (!isVA) {
                  setPopularTestCodes(testCodes);
                } else {
                  setPopularTestCodes([]);
                  vaPanels = window.appConfig.vaPanels;
                  vaTests = []; // Add favorite test codes
                  if (testCodes) {
                    vaTests.push.apply(vaTests, _toConsumableArray(testCodes.map(function (tc) {
                      return {
                        tests: tc.tests
                      };
                    })));
                  }
                  // Add predefined test codes
                  vaTests.push({
                    tests: vaPanels.map(function (panel) {
                      return {
                        code: panel.testCodes[0],
                        testName: panel.testName,
                        id: 0,
                        displayInCatalog: false,
                        displayTestCode: panel.testName === "Single Gene" ? "1300" : ""
                      };
                    })
                  });
                  // Combining all the test objects in a single place
                  completeTests = vaTests[0].tests.concat(vaTests[1].tests); // Filtering out duplicate test objects based on testName
                  uniqueTests = completeTests.filter(function (test, index, self) {
                    return index === self.findIndex(function (t) {
                      return t.testName === test.testName;
                    });
                  });
                  setPopularTestCodes([{
                    tests: uniqueTests
                  }]);
                }
              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    };
    if (popularTestCodes === undefined && !isCatalogPage && selectedInstitution && selectedInstitution.institutionCode && !isOnlyForLoading) {
      getPopular(selectedInstitution.institutionCode);
    }
  }, [popularTestCodes, isCatalogPage, selectedInstitution]);
  var getFavoriteTests = useCallback(function () {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var physicianFavoriteTestDTOs, testsWithNames;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(physician && physician.id)) {
                _context3.next = 17;
                break;
              }
              setLoading(true);
              _context3.prev = 2;
              _context3.next = 5;
              return physiciansApi.getFavoriteTests(physician.id);
            case 5:
              physicianFavoriteTestDTOs = _context3.sent;
              if (!(Array.isArray(physicianFavoriteTestDTOs) && physicianFavoriteTestDTOs.length > 0)) {
                _context3.next = 13;
                break;
              }
              _context3.next = 9;
              return testsApi.getClientTestCodes(physicianFavoriteTestDTOs.map(function (dto) {
                return dto.testCode;
              }));
            case 9:
              testsWithNames = _context3.sent;
              setFavoriteTests(testsWithNames);
              _context3.next = 14;
              break;
            case 13:
              setFavoriteTests([]);
            case 14:
              _context3.prev = 14;
              setLoading(false);
              return _context3.finish(14);
            case 17:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[2,, 14, 17]]);
    }));
  }, [physician, setFavoriteTests]);
  useEffect(function () {
    getFavoriteTests();
  }, []);
  var countAlerts = function countAlerts() {
    if (alertData) {
      var sum = 0;
      Object.values(alertData).map(function (v) {
        return sum += v;
      });
      return sum;
    }
    return 0;
  };
  var alertOpen = Boolean(anchors.notification);
  var alertId = alertOpen ? "simple-popover" : undefined;
  var numberOfAlerts = countAlerts();
  return isCatalogPage ? React.createElement(CatalogHeader, {
    showHamburger: showHamburger
  }) : React.createElement(React.Fragment, null, React.createElement(AppBar, {
    className: classes.appBar
  }, React.createElement(Toolbar, {
    className: classes.toolbar,
    disableGutters: true
  }, React.createElement("div", {
    className: classes.leftSection
  }, isAuthenticated && showHamburger && React.createElement(React.Fragment, null, React.createElement(IconButton, {
    id: "hamburger",
    onClick: function onClick(event) {
      return toggleAnchorClick("menu", event);
    }
  }, React.createElement(MenuIcon, {
    style: {
      color: "#0C2340"
    }
  })), React.createElement(HeaderMenu, {
    anchorEl: anchors.menu,
    open: Boolean(anchors.menu),
    onClose: function onClose() {
      return toggleAnchorClick("menu", undefined);
    }
  })), React.createElement(Link, {
    id: "Header-home-logo",
    to: "/",
    style: {
      width: "fit-content"
    },
    className: classes.logoLink
  }, React.createElement("img", {
    src: logo,
    alt: "baylor-genetics-logo",
    className: classes.headerLogo
  })), showV2ProfileLinks && React.createElement(React.Fragment, null, React.createElement("a", {
    href: "".concat(window.appConfig.v2FEUrl, "/dashboard"),
    className: classes.v2NavLink
  }, "Orders"), React.createElement("a", {
    href: window.appConfig.catalogUrl,
    className: classes.v2NavLink
  }, "Test Catalog"))), React.createElement("div", {
    className: classes.loginContainer
  }, !hideLogin && loginWithRedirect && !isAuthenticated && !!emailVerified && React.createElement(LoginButton, {
    id: "log-in",
    className: classes.loginButton,
    onClick: function onClick() {
      return loginWithRedirect({
        appState: {
          targetUrl: window.location
        }
      });
    }
  }, "LOGIN"), logout && !emailVerified && React.createElement(LoginButton, {
    id: "profile-sign-out",
    className: classes.loginButton,
    onClick: function onClick() {
      return logout({
        returnTo: window.appConfig.auth0Config.logoutRedirectUrl
      });
    }
  }, "LOGOUT"), logout && isAuthenticated && React.createElement(React.Fragment, null, !showV2ProfileLinks && popularTestCodes && institutionCode && React.createElement(React.Fragment, null, React.createElement(OrderDropdown, {
    tests: popularTestCodes,
    loading: loading,
    favorites: favoriteTests,
    institutionCode: institutionCode
  }), !window.appConfig.excludedInsuranceBillingHospitalCodes.includes(institutionCode) && React.createElement(VobDropdown, {
    tests: popularTestCodes
  })), window.appConfig.enableNotifications && React.createElement(React.Fragment, null, React.createElement(Button, {
    id: "Header-notification-button",
    "aria-describedby": alertId,
    onClick: function onClick(event) {
      return toggleAnchorClick("notification", event);
    },
    classes: {
      root: classes.notificationButtonRoot,
      label: classes.notificationButtonLabel
    }
  }, React.createElement(Badge, {
    color: "error",
    invisible: numberOfAlerts === 0,
    variant: "dot",
    className: classes.badge,
    overlap: "rectangular"
  }, React.createElement(NotificationsNoneIcon, {
    className: classes.notificationButtonIcon
  })), React.createElement("span", null, "Notifications")), React.createElement(Popover, {
    id: alertId,
    open: alertOpen,
    anchorEl: anchors.notification,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "left"
    },
    onClose: function onClose() {
      return toggleAnchorClick("notification", undefined);
    },
    disableRestoreFocus: true
  }, React.createElement(HeaderOverlay, {
    data: alertData
  }))), React.createElement(IconButton, {
    id: "profile",
    // className={classes.accountButton}
    onClick: function onClick(event) {
      return toggleAnchorClick("account", event);
    }
  }, React.createElement("img", {
    src: "/images/profile-icon.svg",
    alt: "profile-icon",
    className: classes.iconSize
  })), Boolean(anchors.account) && React.createElement(Menu, {
    id: "profile-menu",
    anchorEl: anchors.account,
    keepMounted: true,
    open: Boolean(anchors.account),
    onClose: function onClose() {
      return toggleAnchorClick("account", undefined);
    },
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "right"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "right"
    }
  }, React.createElement(MenuItem, {
    id: "profile-link",
    className: classes.menuItem,
    onClick: function onClick() {
      return window.open("/profile", "_self");
    }
  }, React.createElement(AccountCircleOutlinedIcon, null), "\xA0\xA0 Profile"), window.appConfig.features.enableUserAdmin && isAdmin && React.createElement(MenuItem, {
    id: "profile-users",
    className: classes.menuItem,
    onClick: function onClick() {
      return window.open("/users", "_self");
    }
  }, React.createElement(PeopleOutlinedIcon, null), "\xA0\xA0 Manage Users"), React.createElement(MenuItem, {
    id: "profile-sign-out",
    className: classes.menuItem,
    onClick: function onClick() {
      return logout({
        returnTo: parcedConfig.type === "SAML_TENANT" ? "".concat(MS_LOGOUT_URL, "?post_logout_redirect_uri=").concat(encodeURIComponent(APP_LOGOUT_REDIRECT)) : window.appConfig.auth0Config.logoutRedirectUrl,
        federated: true
      });
    }
  }, React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M12 3.44995C10.5824 3.44992 9.187 3.80237 7.93945 4.47557C6.69191 5.14877 5.63132 6.1216 4.85315 7.30652C4.07498 8.49143 3.60363 9.85124 3.48154 11.2636C3.35945 12.6759 3.59043 14.0964 4.15371 15.3973C4.71699 16.6982 5.59489 17.8386 6.7084 18.7159C7.82191 19.5932 9.13608 20.1799 10.5326 20.4231C11.9292 20.6664 13.3644 20.5586 14.7089 20.1094C16.0535 19.6602 17.2652 18.8838 18.2352 17.85H21.0792C20.1012 19.3691 18.7574 20.6185 17.1711 21.4833C15.5848 22.3482 13.8067 22.8009 12 22.7999C6.03565 22.7999 1.19995 17.9643 1.19995 12C1.19995 6.03565 6.03565 1.19995 12 1.19995C13.8069 1.19885 15.5851 1.65149 17.1716 2.51636C18.7581 3.38123 20.102 4.63063 21.0801 6.14995H18.2361C17.4373 5.29628 16.4715 4.61605 15.3987 4.15156C14.3259 3.68707 13.169 3.44825 12 3.44995ZM22.8 12L18.75 7.94995H17.4V10.875H8.84995V13.125H17.4V16.05H18.75L22.8 12Z",
    fill: "#0C2340"
  })), "\xA0\xA0 Logout"), React.createElement("span", {
    className: classes.version
  }, process.env.REACT_APP_RELEASE_VERSION)))))));
};
export default withStyles(styles)(Header);